import { FC, useCallback, useEffect, useState } from 'react';
import { observer } from 'mobx-react-lite';
import { useStore } from 'hooks';
import { Select } from 'components';
import { Wrapper } from './fias-select.styled';
import { SelectProps } from 'components/ui/select/select.types';

interface IProps {
  value: string[];
  onChange: (
    houseID: string | null | undefined,
    areaID: string | null | undefined
  ) => void;
  withAreas?: boolean;
  portalContainer?: SelectProps['portalContainer'];
}

/*
  Этот компонент универсальный, зависит только от стора fias.
  Возвращает все значения наверх, контроллируемый компонент.

  Компонент в директории create-request/fias-select не трогал,
  чтобы не сломать создание заявок. 

  TODO адаптировать логику создания заявки под этот компонент
*/
export const FiasSelect: FC<IProps> = observer(
  ({ value, onChange, withAreas = false, portalContainer }) => {
    const { fias } = useStore();
    const [selectedHouseID, setSelectedHouseID] = useState<string | null>(
      value[0] ?? null
    );
    const [selectedAreaID, setSelectedAreaID] = useState<string | null>(
      value[1] ?? null
    );
    // const selectedHouse = useSelectedOption(
    //   fias.addressesList,
    //   selectedHouseID ?? ''
    // );
    // const selectedArea = useSelectedOption(
    //   fias.currentHouseFlatList,
    //   selectedAreaID ?? ''
    // );

    useEffect(() => {
      if (fias.statuses.fiasTree.readyToLoad) {
        fias.getTree();
      }

      setSelectedHouseID(value[0] ?? null);
      setSelectedAreaID(value[1] ?? null);
    }, [value]);

    const handleHouseChange = useCallback(
      (newHouseValue: string | null): void => {
        fias.clearAreas();
        setSelectedHouseID(newHouseValue);
        setSelectedAreaID(null);
        onChange(newHouseValue, null);

        if (newHouseValue && !fias.currentHouseFlatList.length) {
          fias.getAreasByHouse(newHouseValue);
        }
      },
      [onChange, fias.currentHouseFlatList, fias.clearAreas]
    );

    const handleAreaChange = useCallback(
      (newAreaValue: string | null): void => {
        setSelectedAreaID(newAreaValue);

        if (selectedHouseID) {
          onChange(selectedHouseID, newAreaValue);
        }
      },
      [onChange, selectedHouseID]
    );

    return (
      <Wrapper key={'appeal-address-adding'}>
        <Select
          multi={false}
          textOverflowDirection="rtl"
          options={fias.addressesList}
          value={selectedHouseID}
          onChange={handleHouseChange}
          placeholder="Город, улица, дом"
          requiredPlaceholderMark
          loading={fias.statuses.fiasTree.pending}
          loadingText="Ищем дома"
          portalContainer={portalContainer}
        />

        {withAreas && (
          <Select
            multi={false}
            textOverflowDirection="rtl"
            options={fias.currentHouseFlatList}
            value={selectedAreaID}
            onChange={handleAreaChange}
            placeholder="Кв."
            loading={fias.statuses.areasByHouse.pending}
            loadingText="..."
            disabled={!selectedHouseID}
            portalContainer={portalContainer}
          />
        )}
      </Wrapper>
    );
  }
);
